import { getPlural } from '~/utils/stringUtils';
import type { MOQRulesLookup } from '../useProductMOQLimits';

export const getBrandMOQRule = (brand: string, moqRulesLookup: MOQRulesLookup) => {
  const rule = moqRulesLookup.get(brand);
  return rule?.type === 'brand' ? rule : undefined;
};

export const getBrandMOQInfoLabel = (brand: string, moqRulesLookup: MOQRulesLookup) => {
  const rule = getBrandMOQRule(brand, moqRulesLookup);

  if (!rule) {
    return undefined;
  }

  const brandName = rule.target;
  const minQty = rule.minQty && rule.minQty > 1 ? rule.minQty : undefined;
  const { maxQty } = rule;

  if (minQty && maxQty) {
    return `${brandName} orders require a minimum of ${rule.minQty} ${getPlural('item', minQty)} and a maximum of ${maxQty} ${getPlural('item', maxQty)}.`;
  } else if (minQty) {
    return `The brand ${brandName} requires a minimum order quantity of ${minQty} ${getPlural('item', minQty)}.`;
  } else if (maxQty) {
    return `The brand ${brandName} allows a maximum order quantity of ${maxQty} ${getPlural('item', maxQty)}.`;
  }

  return undefined;
};
